// import { TextArea } from 'antd-mobile';
import s from './style.module.scss';
import SkillTemplate from './SkillTemplate';
import { defaultPlaceholder, plugin_json, sendButtonImg } from '@/utils/Page/constant';
import PhoneOutlined from '@/assets/img/icon@2x.png';
import MyIcon from '@/components/MyIcon';
import { Display } from '@/components/Display/Display';
import { cloneDeep } from 'lodash';
import { useEffect, useState } from 'react';
import React from 'react';
import { useJoin } from '@/libTTS/useCommon';
import aigcConfig from '@/configTTS';
import { agentSessionUpsertTTS, checkBusiness } from '@/api/grt/ai';
import { getUserId } from '@/utils/Page';
import ToastUtils from '@/utils/ToastUtils';
import { inject, observer } from 'mobx-react';
import MobileUsualSkillFileUpload from './UsualSkill/FileUpload';
// import AgentFile from './AgentFile';
import SenderFiles from './AgentFile/SenderFiles';
import Reference from './UsualSkill/Reference';
import Config from '@/configTTS';

import { getFileStatus } from '@/utils/Page';
import { Input } from 'antd';
import GrtTextArea from '@/components/Mobile/GrtTextArea';
import { getSkillPluginNames } from '@/utils/Page';
import { pluginMap } from '@/utils/Page/constant';
import ChatTTS from './chatTTS';
const { TextArea } = Input;
const MobileSender = (props) => {
    const { chatStore, skillStore } = props.store;
    const { handlePaste, authTest, content, setContent, agentFile, setAgentFile, references, setReferences } = chatStore;
    const { curSkill, setCurPlugin, curPlugin, isFileChatType } = skillStore;
    const [visible, setVisible] = useState(false);
    const { loading = false, plugins = [], themeColor = 1 } = props;
    const [curPluginIds, setCurPluginIds] = useState([]);
    const onSubmitValue = () => {
        // if (loading || !props.value) {
        //     return false;
        // }
        if (props.onSubmit) {
            props.onSubmit(content);
        }
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (e.shiftKey) {
                // 允许 Shift+Enter 换行（不阻止默认行为）
                return;
            }
            e.preventDefault();
            onSubmitValue();
        }
    };
    const togglePlugin = (item) => {
        let data = cloneDeep(curPlugin) || [];
        let index = data.findIndex((plugin) => plugin.code === item.code);
        if (index == -1) {
            data.push(item);
        } else {
            data.splice(index, 1);
        }

        if (setCurPlugin) {
            setCurPlugin(data);
        }
    };
    useEffect(() => {
        if (curPlugin) {
            let ids = curPlugin.map((item) => item.code);
            setCurPluginIds(ids);
        }
    }, [curPlugin]);
    const toggleShow = () => {
        setVisible(!visible);
    };

    const onCloseTemplate = () => {
        setVisible(false);
    };
    const [joining, dispatchJoin] = useJoin();
    const username = aigcConfig.BaseConfig.UserId;
    const roomId = aigcConfig.BaseConfig.RoomId;

    const setTemplate = (content) => {
        onCloseTemplate();
        setContent(content);
    };
    const getImg = () => {
        let { inUpload, uploadSuccess } = getFileStatus(agentFile);

        if (loading) {
            return sendButtonImg[themeColor].loading;
        }
        if (inUpload.length) {
            return sendButtonImg[themeColor].disable;
        }
        if ((content && content.trim().length) || uploadSuccess.length) {
            return sendButtonImg[themeColor].send;
        }

        return sendButtonImg[themeColor].disable;
    };
    return (
        <>
            <Display show={agentFile.length}>
                <SenderFiles from="sender" needParse={true} fileList={agentFile} setAgentFile={setAgentFile}></SenderFiles>
            </Display>
            <div className={s['mobile-send-wrap']}>
                <SkillTemplate
                    setTemplate={setTemplate}
                    templateList={curSkill?.ability_template_list}
                    onClose={onCloseTemplate}
                    visible={visible}
                ></SkillTemplate>
                <Display show={references.length}>
                    <Reference setReferences={setReferences} files={references}></Reference>
                </Display>

                <div className={s['text-area-wrap']}>
                    <TextArea
                        onPaste={handlePaste}
                        autoSize={{ minRows: 1, maxRows: 3 }}
                        rows={1}
                        value={content}
                        placeholder={props.placeholder || curSkill?.default_prompt}
                        onChange={(e) => {
                            setContent(e.target.value);
                        }}
                    />
                </div>
                <div className={s['bottom']}>
                    <div className={s['plugin-wrap']}>
                        <Display show={curSkill?.ability_template_list && curSkill?.ability_template_list.length}>
                            <div
                                data-checked={visible}
                                className={s['plugin-item']}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    toggleShow();
                                }}
                            >
                                <MyIcon className={s['plugin-icon']} type={'icon-a-moban'}></MyIcon>
                                模板
                            </div>
                        </Display>
                        {plugins.map((item, index) => {
                            return (
                                <React.Fragment key={index}>
                                    <Display show={item.code === 1 && item.choice !== 1}>
                                        <div
                                            data-checked={item.choice === 1 || curPluginIds.includes(item.code)}
                                            onClick={() => {
                                                togglePlugin(item);
                                            }}
                                            className={s['plugin-item']}
                                            key={index}
                                        >
                                            <MyIcon className={s['plugin-icon']} type={plugin_json[item.code].type}></MyIcon>
                                            <span>{plugin_json[item.code].name}</span>
                                        </div>
                                    </Display>
                                    <Display show={item.code === 0}>
                                        <div
                                            data-checked={item.choice === 1 || curPluginIds.includes(item.code)}
                                            onClick={() => {
                                                togglePlugin(item);
                                            }}
                                            className={s['plugin-item']}
                                            key={index}
                                        >
                                            <MyIcon className={s['plugin-icon']} type={plugin_json[item.code].type}></MyIcon>
                                            <span> {item.choice === 1 ? `${plugin_json[item.code].name}：开` : plugin_json[item.code].name}</span>
                                        </div>
                                    </Display>
                                </React.Fragment>
                            );
                        })}
                        <Display show={typeof isFileChatType === 'function' && isFileChatType(curSkill?.ability_id)}>
                            <MobileUsualSkillFileUpload
                                authTest={authTest}
                                agentFile={agentFile}
                                setAgentFile={setAgentFile}
                                setReferences={setReferences}
                            ></MobileUsualSkillFileUpload>
                        </Display>
                    </div>
                    <div className={s['bottom-right']}>
                        <ChatTTS {...props} />
                        <img
                            className={s['send-img']}
                            onClick={(e) => {
                                e.preventDefault();
                                onSubmitValue();
                            }}
                            src={getImg()}
                            alt=""
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default inject('store')(observer(MobileSender));
